import axios from 'axios';
import _each from 'lodash/each';
import _mapValues from "lodash/mapValues";
import Modal from "../modules/modal/modal";
import overlay from '../modules/loader';

const instance = axios.create();

let container = null;
let axiosCount = 0;
let loading = false;

const setLoading = active => {
    if (active) {
        axiosCount++;
        loading = true;
    } else if (axiosCount > 0) {
        axiosCount--;
        loading = axiosCount > 0;
    }

    if (loading) {
        overlay(true);
        $('#loadingToast').toast('show');
    } else {
        overlay(false);
        $('#loadingToast').toast('hide');
    }
};

const handleNotifications = response => {
    setLoading(false);

    if (response?.data?._flash_notification) {
        // found a notifications within the response, so we create several toasts for this
        // create container for positioning
        if (container === null) {
            container = $('<div class="toast-container position-fixed top-18 end-0 p-3 p-lg-3 z-index-99"></div>');
            $('body').append(container);
        }
        _each(response.data?._flash_notification ?? [], (notification) => {
            // create toast element:
            const element = $(
                `    <div class="toast align-items-center alert-${notification.level ?? 'info'} border-0" role="alert" data-animation="true">\n` +
                '        <div class="d-flex">\n' +
                '            <div class="toast-body">\n' +
                `                ${notification.message}\n` +
                '            </div>\n' +
                '            <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close">\n' +
                '                <i class="fal fa-times"></i>\n' +
                '            </button>\n' +
                '        </div>\n' +
                '    </div>');
            container.append(element); // append element to container
            element.toast('show'); // call the show method
        });
    }

    return response;
}

const handleError = error => {
    setLoading(false);

    if (error instanceof axios.Cancel) {
        return Promise.reject(error)
    }
    const {status} = error?.response?.status;

    handleNotifications(error.response);

    // Show the user a 500 error or the forbidden state
    if (status === 403 || status >= 500) {
      //  window.location.href = window.config.urls.err.replace(':status:', status);
    }

    // Handle Session Timeouts
    if (status === 401) {
        window.location.href = window.config.urls.login;
    }

    if (error.response?.status === 422) {
        const errors = Object.values(_mapValues(error.response.data?.errors ?? {}, (item, key) => {
            return item[0]
        }));
        if (errors.length === 0) {
            errors.push(error.response.data.message)
        }
        let errorModal = new Modal({
            title: window.config.language.errorOccurred,
            content: Modal.createErrorMessage('<ul><li>' + errors.join('</li><li>') + '</li></ul>'),
            buttons: Modal.buttons.alert,
        })

        errorModal.show();

        // Focus Modal Dismiss Button
        const errorModalFooter = errorModal.el.querySelector('.modal-footer')
        const errorModalDismissBtn = errorModalFooter.querySelector('[data-dismiss="modal"]')
        errorModalDismissBtn.focus();

    }

    // Handle Token Timeouts
    if (status === 419) {
        window.location.reload();
    }

    return Promise.reject(error);
};

instance.interceptors.response.use(
    handleNotifications,
    handleError
);
instance.interceptors.request.use(config => {
    if (config.overlay) {
        setLoading(true);
    }

    return config;
},
    handleError
);
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector(
    'meta[name="csrf-token"]'
).content

export default instance;
